import NewsCard from "../../Components/NewsCard/NewsCard";
import { useConfigStore } from "../../Stores/Config";
import { useNewsStore } from "../../Stores/News";
import { ReactComponent as AnnouncementsActive } from '../../Assets/megaphone-solid.svg';
import "./News.scss";

function News() {
    const newsStore = useNewsStore();
    const articles = useNewsStore(state => state.articles);
    const configStore = useConfigStore();

    return (
        <div className="news">
            {newsStore.articles.length === 0 && !newsStore.loadingNews && (
                <div className="no-news">
                    <AnnouncementsActive className="no-news-yet" />
                    <span className="title">{configStore.config.newsMenuLabel}</span>
                    <span className="description">{configStore.translateText("noNews")}</span>
                </div>
            )}
            {articles.map((news) => {
                return <NewsCard news={news} key={news.id} />
            })}
            {(newsStore.articles.length !== 0 && newsStore.currentOffset % 10 === 0) &&
                <div className={`load-more`} onClick={() => {
                    newsStore.loadMoreNews();
                }}>
                    <span>{configStore.translateText("loadMore")}</span>
                </div>}
        </div>
    );
}

export default News;
